(function($, d, g) {
    'use strict';

    // --- Configurations & Cache Settings ---
    const CACHE_KEY = "member_directory_all_data";
    const CACHE_TIME_KEY = "member_directory_all_timestamp";
    const CACHE_DURATION = 1000 * 60 * 60 * 4; // 4 Hours Expiration Guard
    const ITEMS_PER_PAGE = 10;

    let allMembers = [];
    let filteredMembers = [];
    let currentPage = 1;

    // Detect if Admin is logged in based on shell attribute
    const isAdmin = $(".shell").attr("data-admin-logged") === "true";
    const urlParams = new URLSearchParams(window.location.search);
    const activeMemberID = urlParams.get('mID');

    const filterData = {
        "Type of Connection": ["Networking / Career opportunities", "Consulting / freelance opportunities", "Expertise requests", "Speaking opportunities", "Chapter Leadership", "Volunteering", "Job Search"],
        "Experience Level": ["Student", "Entry Level", "Associate", "Mid-Senior", "Director", "Executive"],
        "Industry": ["Aerospace", "Architecture/Engineering", "Construction", "Automotive", "Chemical", "Education", "Energy and Utilities", "Financial Services", "Food/Entertainment", "Hospitality", "Healthcare", "Manufacturing", "Media", "Non-profit", "Professional Services", "Real Estate", "Technology", "Telecommunication", "Other"],
        "Expertise": ["Business Analysis", "Change Management", "Leadership", "Organizational Design", "Portfolio Management", "Program Management", "Project Management", "Project Management Office (PMO)/Enterprise PMO", "Risk Management", "Strategy", "Other"],
        "Location": ["Manhattan", "Brooklyn", "Queens", "Bronx", "Staten Island", "Long Island or Westchester", "NYS Other", "Tristate", "US – outside tristate", "International"],
        "Certifications": ["PMP", "CAPM", "PgMP", "PMI-ACP", "CPMAI", "Accounting", "Amazon Web Services", "Construction", "Energy and Environmental", "Engineering", "Finance", "Google", "Healthcare", "Human Resources", "Information Technology", "Management", "Microsoft", "Six Sigma / Quality", "Supply Chain", "Other"]
    };

    const profileGroups = {
        "typeConn": ["Networking / Career opportunities", "Consulting / freelance opportunities", "Expertise requests", "Speaking opportunities", "Chapter Leadership", "Volunteering", "Job Search"],
        "industry": ["Aerospace", "Architecture/Engineering", "Construction", "Automotive", "Chemical", "Education", "Energy and Utilities", "Financial Services", "Food/Entertainment", "Hospitality", "Healthcare", "Manufacturing", "Media", "Non-profit", "Professional Services", "Real Estate", "Technology", "Telecommunication", "Other"],
        "projExp": ["Business Analysis", "Change Management", "Leadership", "Organizational Design", "Portfolio Management", "Program Management", "Project Management", "Project Management Office (PMO)/Enterprise PMO", "Risk Management", "Strategy", "Other"],
        "workLocation": ["Manhattan", "Brooklyn", "Queens", "Bronx", "Staten Island", "Long Island or Westchester", "NYS Other", "Tristate", "US – outside tristate", "International"],
        "nonPmiCert": ["Accounting", "Amazon Web Services", "Construction", "Energy and Environmental", "Engineering", "Finance", "Google", "Healthcare", "Human Resources", "Information Technology", "Management", "Microsoft", "Six Sigma / Quality", "Supply Chain", "Other"]
    };

    function init() {
        // Initialize dynamic DOM setups
        if ($("#filterGroups").length > 0) initFilters();
        if ($("#profileChecks").length > 0) initProfileGroups();

        // LOAD DATA: Cache-first fetching flow
        fetchAndLoadMembers();
        updateLivePreview();

        // Match checkbox values to URL params (if present)
        const params = new URLSearchParams(window.location.search);
        const $filterForm = $("#memberDirectoryFilterForm");
        params.forEach((value, key) => {
            $filterForm.find(`input[name='${key}'][value='${value}']`).prop('checked', true);
        });

        // Tab State Router Setup
        if ($('.tab').length > 0) {
            $('.tab').on('click', function(e) {
                e.preventDefault();
                const tabId = $(this).data('tab');
                if (tabId) {
                    sessionStorage.setItem('activeMemDirTab', tabId);
                    activateMemberDirTab(tabId);
                }
            });

            const savedTab = sessionStorage.getItem('activeMemDirTab');
            activateMemberDirTab(savedTab && $('#' + savedTab).length > 0 ? savedTab : 'directory');
        }

        $("#refreshDirectory").on("click", function(e) {
            e.preventDefault();

            localStorage.removeItem(CACHE_KEY);
            localStorage.removeItem(CACHE_TIME_KEY);

            fetchAndLoadMembers(true);
        });

        // Clear Filters Action
        $("#clearFilters").on("click", function(e) {
            e.preventDefault();
            e.stopPropagation();
            $("#filterGroups input[type='checkbox']").prop("checked", false);
            $("#search").val("");
            $("#activeCount").text("0 active");
            filteredMembers = [...allMembers];
            currentPage = 1;
            renderDirectory();
        });

        // Search & Filter Events
        $("#searchBtn").on("click", function() { currentPage = 1; applyFiltersAndSearch(); });
        $("#search").on("keydown", function(e) { 
            if (e.key === "Enter") { 
                e.preventDefault(); 
                currentPage = 1;
                applyFiltersAndSearch(); 
            } 
        });
        $("#applyFilters").on("click", function() { currentPage = 1; applyFiltersAndSearch(); });
        $("#sort").on("change", function() { currentPage = 1; renderDirectory(); });

        // Visibility toggler handler
        $(".member-search-visibility").on("change", handleVisibilityToggle);

        // CSV Export
        $("#exportCsv").on("click", function() {
            const rows = [
                ["First Name", "Last Name", "Preferred Name", "Email", "Certification", "About Me", "Company", "Experience", "Industry", "Expertise", "Location", "Non-PMI Certification", "Connections", "LinkedIn"],
                ...filteredMembers.map(m => [m.first, m.last, m.preferName, m.email, m.cert, m.about, m.company, m.experience, m.industry, m.expertise, m.location, m.nonPmiCert, m.typeConn, m.linkedin])
            ];
            const csv = rows.map(r => r.map(v => `"${String(v || "").replace(/"/g, '""')}"`).join(",")).join("\n");
            const a = document.createElement("a");
            a.href = URL.createObjectURL(new Blob([csv], { type: "text/csv;charset=utf-8;" }));
            a.download = "member-directory-results.csv";
            a.click();
            URL.revokeObjectURL(a.href);
        });

        // Prevent manual tampering of readonly fields
        $("input[readonly]").on("keydown paste change focus", function(e) {
            $(this).blur();
            e.preventDefault();
            return false;
        });

        // Precheck Multi-select Checkboxes on profile edit load
        const fieldMappings = [
            { hidden: 'typeConnValue', cbName: 'typeConn_cb' },
            { hidden: 'industryValue', cbName: 'industry_cb' },
            { hidden: 'projExpValue', cbName: 'projExp_cb' },
            { hidden: 'workLocationValue', cbName: 'workLocation_cb' },
            { hidden: 'nonPmiCertValue', cbName: 'nonPmiCert_cb' }
        ];

        fieldMappings.forEach(map => {
            const $hiddenInput = $(`#${map.hidden}`);
            if ($hiddenInput.length && $.trim($hiddenInput.val()) !== '') {
                const selectedValues = $hiddenInput.val().split(/[,;]/).map(v => $.trim(v).toLowerCase());
                $(`input[name='${map.cbName}']`).each(function() {
                    if (selectedValues.indexOf($(this).val().toLowerCase()) !== -1) {
                        $(this).prop('checked', true);
                    }
                });
            }
        });

        // Real-time DOM values sync
        $('#profileForm').on('change', 'input[type="checkbox"]', function() {
            const name = $(this).attr('name');
            if (name && name.endsWith('_cb')) {
                const baseName = name.replace('_cb', '');
                updateHiddenInput(name, baseName + 'Value');
            }
            updateLivePreview();
        });

        // Save Profile via Validation & AJAX Context Syncing
        $("#profileForm").on("submit", function(e) {
            e.preventDefault(); 
            
            if (!validateProfileForm()) return false;

            updateHiddenInput('typeConn_cb', 'typeConnValue');
            updateHiddenInput('industry_cb', 'industryValue');
            updateHiddenInput('projExp_cb', 'projExpValue');
            updateHiddenInput('workLocation_cb', 'workLocationValue');
            updateHiddenInput('nonPmiCert_cb', 'nonPmiCertValue');

            const form = this;
            const actionUrl = $(form).attr("action");
            //const formData = $(form).serialize();
            const formData = new FormData(form);

            $.ajax({
                url: actionUrl,
                method: "POST",
                data: formData,
                processData: false,
                contentType: false,
                success: function() {
                    localStorage.removeItem(CACHE_KEY);
                    localStorage.removeItem(CACHE_TIME_KEY);

                    $("#saveStatus").addClass("show");
                    setTimeout(() => $("#saveStatus").removeClass("show"), 4000);

                    fetchAndLoadMembers(true);
                    // window.location.reload();
                },
                error: function(err) {
                    console.error("Save profile error", err);
                    alert("Unable to save profile context. Check network connections and try again.");
                }
            });
        });

        // Image file picker listener
        $("#photo").on("change", function(e) {
            const file = e.target.files[0];

            $("#removeMedia").val("false");

            if (!file) return;
            const reader = new FileReader();
            reader.onload = () => {
                $("#uploadPreviewImg").attr("src", reader.result);
                $("#uploadPreviewCtn").css("display", "inline-block");
                $("#fileInputWrap").hide();
                $("#previewAvatar").html(`<img src="${reader.result}" alt="Profile preview" style="width:100%;height:100%;object-fit:cover;border-radius:50%">`);
            };
            reader.readAsDataURL(file);
        });

        // Remove photo handler
        $("#removePhoto").on("click", function() {
            $("#removeMedia").val("true");
            $("#photo").val("");
            $("#uploadPreviewCtn").hide();
            $("#uploadPreviewImg").attr("src", "");
            $("#fileInputWrap").show();
            
            const firstName = $.trim($("#firstName").val() || "");
            const lastName = $.trim($("#lastName").val() || "");
            const displayName = $.trim($("#preferredName").val() || "") || firstName;
            
            const firstInitial = displayName.charAt(0).toUpperCase();
            const lastInitial = lastName.charAt(0).toUpperCase();
            $("#previewAvatar").text(firstInitial + lastInitial);
        });

        // Watch profile live edits (inputs, textareas, and selects)
        ["preferredName", "company", "about", "linkedin"].forEach(id => {
            $(`#${id}`).on("input", updateLivePreview);
        });
        $("select[name='experience']").on("change", updateLivePreview);

        // Edit button handler in Directory Search (Admin mode)
        $("#cards").on("click", ".edit-member-btn", function() {
            const memberId = $(this).data("id");
            if (memberId) {
                // Set the profile tab as active upon reload
                sessionStorage.setItem('activeMemDirTab', 'profile');
                // Redirect to loaded member's context
                window.location.href = window.location.pathname + "?mID=" + memberId;
            }
        });

        // Direct Deletion Action (Admins only, inside visibility panel)
        $("#deleteProfileAdmin").on("click", function(e) {
            e.preventDefault();
            if (!activeMemberID) return;

            const name = $("#previewName").text() || "this user";
            const message = `Are you sure you want to continue? This action can be reversed later.`;

            showConfirmModal(message, function() {
                $.ajax({
                    url: "/action/deleteMemberProfile",
                    method: "POST",
                    data: { pmiID: activeMemberID },
                    success: function() {
                        localStorage.removeItem(CACHE_KEY);
                        localStorage.removeItem(CACHE_TIME_KEY);
                        alert("Profile status has been updated.");
                        // Redirect back to standard directory without mID parameter
                        //window.location.href = window.location.pathname;
                        window.location.reload();
                    },
                    error: function(err) {
                        console.error("Delete profile error", err);
                        alert("Failed to delete the profile. Please check permissions and try again.");
                    }
                });
            });
        });
    }

    // --- Loading & Caching Middleware ---
    function fetchAndLoadMembers(forceRefresh = false) {
        const cachedData = localStorage.getItem(CACHE_KEY);
        const cachedTime = localStorage.getItem(CACHE_TIME_KEY);
        const now = Date.now();

        if (!forceRefresh && cachedData && cachedTime && (now - cachedTime < CACHE_DURATION)) {
            allMembers = JSON.parse(cachedData);
            filteredMembers = [...allMembers];
            renderDirectory();
            return;
        }

        $("#cards").html('<div class="empty"><h3>Loading directory Members...</h3></div>');

        $.ajax({
            url: "/action/directoryMembers",
            method: "GET",
            dataType: "json",
            success: function(data) {
                allMembers = data;
                filteredMembers = [...allMembers];
                
                localStorage.setItem(CACHE_KEY, JSON.stringify(data));
                localStorage.setItem(CACHE_TIME_KEY, now);
                
                renderDirectory();
            },
            error: function(err) {
                if (cachedData) {
                    allMembers = JSON.parse(cachedData);
                    filteredMembers = [...allMembers];
                    renderDirectory();
                } else {
                    $("#cards").html('<div class="empty"><h3>No members directory found</h3><p>Try clearing filters or broadening search parameters.</p></div>');
                }
            }
        });
    }

    // --- Render Pagination Controls ---
    function renderPagination(totalItems) {
        const totalPages = Math.ceil(totalItems / ITEMS_PER_PAGE);
        const $paginationCtn = $("#paginationContainer");

        if (totalPages <= 1) {
            $paginationCtn.empty();
            return;
        }

        let buttonsHtml = `<div class="pagination-bar">`;
        buttonsHtml += `<button class="pagination-btn" id="paginationPrev" ${currentPage === 1 ? 'disabled' : ''}>Back</button>`;

        for (let i = 1; i <= totalPages; i++) {
            if (i === 1 || i === totalPages || (i >= currentPage - 2 && i <= currentPage + 2)) {
                buttonsHtml += `<button class="pagination-btn ${currentPage === i ? 'active' : ''}" data-page="${i}">${i}</button>`;
            } else if (i === currentPage - 3 || i === currentPage + 3) {
                buttonsHtml += `<span style="padding: 0 4px">...</span>`;
            }
        }

        buttonsHtml += `<button class="pagination-btn" id="paginationNext" ${currentPage === totalPages ? 'disabled' : ''}>Next</button>`;
        buttonsHtml += `</div>`;

        $paginationCtn.html(buttonsHtml);

        $(".pagination-btn").on("click", function() {
            if ($(this).is(":disabled")) return;

            let targetPage = parseInt($(this).data("page"), 10);
            if ($(this).attr("id") === "paginationPrev") {
                targetPage = currentPage - 1;
            } else if ($(this).attr("id") === "paginationNext") {
                targetPage = currentPage + 1;
            }

            if (targetPage && targetPage !== currentPage) {
                currentPage = targetPage;
                renderDirectory();
                $('html, body').animate({ scrollTop: $("#directory").offset().top - 80 }, 200);
            }
        });
    }

    // --- Dynamic Filters Rendering ---
    function initFilters() {
        $("#filterGroups").html(Object.entries(filterData).map(([g, opts]) => `
            <div class="fg closed">
                <button type="button" aria-expanded="false">
                    <span>${g}</span>
                    <span class="arrow-indicator">▼</span>
                </button>
                <div class="opts">
                    ${opts.map(o => `<label class="opt"><input type="checkbox" data-group="${g}" value="${o}"/> ${o}</label>`).join("")}
                </div>
            </div>
        `).join(""));

        $(".fg > button").on("click", function() {
            const $g = $(this).parent();
            $g.toggleClass("closed");
            const isClosed = $g.hasClass("closed");
            $(this).find(".arrow-indicator").text(isClosed ? "▼" : "▲");
            $(this).attr("aria-expanded", !isClosed);
        });

        $("#filterGroups input").on("change", function() {
            const n = $("#filterGroups input:checked").length;
            $("#activeCount").text(`${n} active`);
        });
    }

    // --- Dynamic Checkbox Grid Builder ---
    function initProfileGroups() {
        $("#profileChecks").html(Object.entries(profileGroups).map(([g, opts]) => `
            <div class="section">
                <div class="legend" style="text-transform: capitalize;">${g.replace('Value','').replace('typeConn','Types of Connection').replace('projExp', 'Expertise').replace('workLocation', 'Work Location').replace('nonPmiCert', 'Non-PMI Certifications')} ${g !== 'nonPmiCert' ? ' *' : ''}</div>
                <div class="checkgrid">
                    ${opts.map(o => `<label class="opt"><input type="checkbox" name="${g}_cb" value="${o}"/> ${o}</label>`).join("")}
                </div>
            </div>
        `).join(""));
    }

    // --- In-Memory Search Engine ---
    function applyFiltersAndSearch() {
        const queryTerms = $("#search").val().toLowerCase().split(",").map(x => x.trim()).filter(Boolean);
        const selectedFilters = {};

        $("#filterGroups input:checked").each(function() {
            const group = $(this).data('group');
            if (!selectedFilters[group]) selectedFilters[group] = [];
            selectedFilters[group].push($(this).val().toLowerCase());
        });

        filteredMembers = allMembers.filter(m => {
            const haystack = Object.values(m).join(" ").toLowerCase();
            // if (queryTerms.length && !queryTerms.some(term => haystack.includes(term))) {
            //     return false;
            // }
            if (
                queryTerms.length &&
                !queryTerms.some(term => {
                    const escapedTerm = term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
                    const wordPattern = new RegExp(`\\b${escapedTerm}\\b`, 'i');

                    return wordPattern.test(haystack);
                })
            ) {
                return false;
            }

            const schemaMap = {
                "Experience Level": "experience",
                "Industry": "industry",
                "Expertise": "expertise",
                "Location": "location",
                "Certifications": "cert",
                "Type of Connection": "typeConn"
            };

            return Object.entries(selectedFilters).every(([groupTitle, selectedArray]) => {
                const targetKey = schemaMap[groupTitle];
                const memberValue = (m[targetKey] || "").toLowerCase();
                return selectedArray.some(val => memberValue.includes(val));
            });
        });

        renderDirectory();
    }

    // --- Main Directory Grid Rendering Engine ---
    function renderDirectory() {
        if ($("#cards").length === 0) return;

        const sortMode = $("#sort").val();
        const sortKey = sortMode === "first" ? "first" : sortMode === "company" ? "company" : "last";
        
        filteredMembers.sort((a, b) => {
            const valA = (a[sortKey] || "").toString().trim();
            const valB = (b[sortKey] || "").toString().trim();
            return valA.localeCompare(valB);
        });

        $("#resultCount").text(`${filteredMembers.length} member${filteredMembers.length === 1 ? "" : "s"}`);

        const startOffset = (currentPage - 1) * ITEMS_PER_PAGE;
        const pageSlice = filteredMembers.slice(startOffset, startOffset + ITEMS_PER_PAGE);

        if (pageSlice.length === 0) {
            $("#cards").html(`<div class="empty"><h3>No members directory found</h3><p>Try clearing filters or broadening search parameters.</p></div>`);
            $("#paginationContainer").empty();
            return;
        }

        $("#cards").html(pageSlice.map(m => {
            const memberId = m.pmiNumber || m.id || m.pmiID || "";

            const displayName = m.preferName
                    ? `${m.first || ""} (${m.preferName}) ${m.last || ""}`.trim()
                    : `${m.first || ""} ${m.last || ""}`.trim();

            const initials =
                `${m.first ? m.first.charAt(0).toUpperCase() : ""}` +
                `${m.last ? m.last.charAt(0).toUpperCase() : ""}`;

            return `
            <div class="directory-profile-card">

                <div class="directory-summary">

                    <div class="directory-summary-left">

                        <div class="avatar">
                            ${
                                Number(m.mediaId) > 0
                                    ? `<img src="/static/uploaded/MemberDirectoryImages/${m.mediaId}-preview.jpg" alt="${displayName}">`
                                    : initials
                            }
                        </div>

                        <div class="directory-summary-content" style="margin-top: 15px">
                            <h3>${displayName}</h3>

                            ${m.company ? `
                                <div class="company">
                                    ${m.company}
                                </div>
                            ` : ""}
                        </div>
                    </div>

                    <div class="directory-summary-right">
                        ${isAdmin && memberId ? `<button type="button" class="iconbtn edit-member-btn" onclick="window.location.href='members-search?mID=${memberId}'"  
                        style="border-color: var(--p); color: var(--p);">✏️ Edit Profile</button>` : ""}


                        ${m.linkedin ? `
                            <a
                                class="linkedin-btn"
                                href="${m.linkedin}"
                                target="_blank"
                                rel="noopener noreferrer">
                                LinkedIn ↗
                            </a>
                        ` : ""}
                    </div>
                </div>
                <div style="margin: 18px">

                    <aside class="profile-preview-sidebar">

                        ${m.about ? `
                                <div class="preview-about">
                                    <h4>About Me</h4>
                                    <p>${m.about}</p>
                                </div>
                            ` : ""}

                        ${isAdmin  && memberId? `
                            <div class="preview-section preview-admin-section">

                                <div class="preview-section-title">
                                    Administrative Information
                                </div>

                                <div class="preview-details">

                                    <div class="preview-detail-row">
                                        <span class="preview-detail-label">PMI Number</span>
                                        <strong class="preview-detail-value">#${memberId}</strong>
                                    </div>

                                    <div class="preview-detail-row">
                                        <span class="preview-detail-label">Email</span>
                                        <strong class="preview-detail-value">${m.email || ""}</strong>
                                    </div>

                                </div>

                            </div>
                        ` : ""}

                    </aside>

                    <div class="summary-tags">

                        ${m.cert ? `
                            <span class="tag">
                                🏅 ${m.cert}
                            </span>
                        ` : ""} 

                        ${m.experience ? `
                            <span class="tag">
                                💼 ${m.experience}
                            </span>
                        ` : ""}
                        
                        ${m.location ? `
                            <span class="tag">
                                📍 ${m.location}
                            </span>
                        ` : ""}

                    </div>
                </div>

                <div class="directory-details">

                    <div class="directory-info-grid">

                        ${m.typeConn ? `
                            <div class="directory-info-item">
                                <strong>🤝 Connections</strong>
                                <div>${m.typeConn}</div>
                            </div>
                        ` : ""}

                        ${m.industry ? `
                            <div class="directory-info-item">
                                <strong>🏷️ Industry</strong>
                                <div>${m.industry}</div>
                            </div>
                        ` : ""}

                        ${m.expertise ? `
                            <div class="directory-info-item">
                                <strong>💡 Expertise</strong>
                                <div>${m.expertise}</div>
                            </div>
                        ` : ""}

                        ${m.nonPmiCert ? `
                            <div class="directory-info-item">
                                <strong>📜 Non-PMI Certifications</strong>
                                <div>${m.nonPmiCert}</div>
                            </div>
                        ` : ""}

                    </div>

                </div>

            </div>
            `;
        }).join(""));

        renderPagination(filteredMembers.length);
    }

    $("#cards").on("click",".directory-summary",function(e){

        if($(e.target).closest(".linkedin-btn").length)
            return;

        const card=$(this).closest(".directory-profile-card");

        $(".directory-profile-card")
            .not(card)
            .removeClass("expanded");

        card.toggleClass("expanded");

    });

    $("#cards").on("click",".linkedin-btn",function(e){

        e.stopPropagation();

    });

    // --- Validation Logic ---
    function validateProfileForm() {
        $(".input-error").removeClass("input-error");
        $(".error-text").remove();
        
        let isValid = true;

        const markErr = (id, message) => {
            const $field = $(`#${id}`);
            $field.addClass("input-error");
            $field.after(`<span class="error-text">${message}</span>`);
            isValid = false;
        };

        if ($.trim($("#firstName").val()) === "") markErr("firstName", "First Name is required.");
        if ($.trim($("#lastName").val()) === "") markErr("lastName", "Last Name is required.");
        
        const email = $.trim($("#email").val());
        if (email === "" || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            markErr("email", "Please enter a valid email.");
        }

        if ($.trim($("#phone").val()) === "") markErr("phone", "Phone is required.");
        
        const linkedin = $.trim($("input[name='linkedInUrl']").val());
        const linkedinReg = /^https?:\/\/(www\.)?linkedin\.com\/[^\s]+$/i;
        if (linkedin === "" || !linkedinReg.test(linkedin)) {
            markErr("linkedin", "Please enter a valid LinkedIn URL");
        }

        if (!$("select[name='experience']").val()) {
            markErr("experience", "Experience Selection is required.");
        }

        const groupsToVerify = ['typeConn_cb', 'industry_cb', 'projExp_cb', 'workLocation_cb'];
        groupsToVerify.forEach(name => {
            if ($(`input[name='${name}']:checked`).length === 0) {
                const $ctn = $(`input[name='${name}']`).closest('.section');
                $ctn.addClass("input-error");
                $ctn.append('<span class="error-text">Please select at least one option.</span>');
                isValid = false;
            }
        });

        if ($("input[name='termsCheck']").length && !$("input[name='termsCheck']").is(':checked')) {
            const $group = $("input[name='termsCheck']").closest('.section');
            $group.addClass("input-error");
            $group.append('<span class="error-text">Please accept the required terms to continue.</span>');
            isValid = false;
        }

        if (!isValid) {
            $('html, body').animate({ scrollTop: $(".input-error").first().offset().top - 120 }, 300);
        }

        return isValid;
    }

    function updateHiddenInput(cbName, hiddenId) {
        const values = $(`input[name="${cbName}"]:checked`).map(function() { return $(this).val(); }).get().join(', ');
        $(`#${hiddenId}`).val(values);
    }

    function activateMemberDirTab(tabId) {
        if (!tabId) return;
        $('.tab').removeClass('active');
        $('.panel').removeClass('active');
        $(`.tab[data-tab="${tabId}"]`).addClass('active');
        $('#' + tabId).addClass('active');
    }

    // --- Side Preview Dynamic Synchronizer ---
    function updateLivePreview() {
        const first = $.trim($("#firstName").val() || "");
        const last = $.trim($("#lastName").val() || "");
        const pref = $.trim($("#preferredName").val() || "");
        const comp = $.trim($("#company").val() || "");
        const about = $.trim($("#about").val() || "");
        const linkedin = $.trim($("#linkedin").val() || "");

        const displayName = pref || first;

        // Identity Strings Sync (With matching emoji integration)
        if ($("#previewName").length) $("#previewName").text(`${displayName} ${last}`.trim());
        if ($("#previewCompany").length) $("#previewCompany").text(comp ? `🏢 ${comp}` : "Company not provided");
        if ($("#previewAbout").length) $("#previewAbout").text(about || "No About Me content provided.");
        if ($("#previewLinkedin").length) $("#previewLinkedin").attr("href", linkedin || "#").css("display", linkedin ? "flex" : "none");
        if ($("#aboutCount").length) $("#aboutCount").text(about.length);

        // Standard Fallback Avatar Setup
        if ($("#previewAvatar").length && !$("#previewAvatar").find("img").length) {
            const firstInitial = displayName.charAt(0).toUpperCase();
            const lastInitial = last.charAt(0).toUpperCase();
            $("#previewAvatar").text(firstInitial + lastInitial);
        }

        // Professional Selection Box Text Synchronizer (Appends matching icon prefixes)
        const blockMappings = [
            { name: 'experience_cb', label: '💼 Experience', target: 'experience' },
            { name: 'typeConn_cb', label: '🤝 Types of Connections', target: 'typeConn' },
            { name: 'industry_cb', label: '🏷️ Industry', target: 'industry' },
            { name: 'projExp_cb', label: '💡 Expertise', target: 'projExp' },
            { name: 'workLocation_cb', label: '📍 Work Location', target: 'workLocation' },
            { name: 'nonPmiCert_cb', label: '📜 Non-PMI Certifications', target: 'nonPmiCert' }
        ];

        blockMappings.forEach(mapping => {
            let selectedText = '';
            
            if (mapping.target === 'experience') {
                selectedText = $("select[name='experience']").val() || '';
            } else {
                selectedText = $(`input[name="${mapping.name}"]:checked`).map(function() { 
                    return $(this).val(); 
                }).get().join(', ');
            }
        });
    }

    function showConfirmModal(message, onConfirm, onCancel) {
        $("#modalText").text(message);
        $("#modal").addClass("open");
        
        $("#modalConfirm").off("click").on("click", function() {
            $("#modal").removeClass("open");
            if (typeof onConfirm === "function") onConfirm();
        });
        
        $("#modalCancel").off("click").on("click", function() {
            $("#modal").removeClass("open");
            if (typeof onCancel === "function") onCancel();
        });
    }

    function handleVisibilityToggle() {
        const checkbox = this;
        const isChecked = checkbox.checked;
        const action = isChecked ? "ENABLE" : "DISABLE";
        const message = `Are you sure you want to ${action} your visibility?`;

        checkbox.checked = !isChecked; 

        showConfirmModal(message, function() {
            checkbox.checked = isChecked;
            const pmiID = $.trim($("input[name='pmiID']").val());

            $.ajax({
                url: "/action/changeVisibility",
                method: "POST",
                data: { status: isChecked, pmiID: pmiID },
                success: function() {
                    localStorage.removeItem(CACHE_KEY);
                    localStorage.removeItem(CACHE_TIME_KEY);
                    window.location.reload();
                },
                error: function() {
                    alert("Could not save visibility settings. Try again later.");
                    checkbox.checked = !isChecked;
                }
            });
        }, function() {
            checkbox.checked = !isChecked;
        });
    }

    $(g).ready(init);

})(jQuery, document, window);